// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"2107243b","30":"f836e4e7","186":"7d7e499f","225":"3cce2beb","272":"da19d957","372":"706213b3","377":"b1025126","738":"cc23a783","841":"cc7067be","851":"3089a7db","856":"0c5d3f19"}[chunkId] + ".chunk.js";
};